var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.75102e-08 2.00044C-3.91383e-08 3.10706 0.895379 4.00244 2.0004 4.00244C3.08622 4.00244 3.97119 3.13587 4 2.05405L4 1.94683C3.97119 0.866614 3.08622 4.13499e-05 2.0004 4.13974e-05C0.895379 4.14457e-05 -1.35777e-07 0.89622 -8.75102e-08 2.00044Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.74403e-08 9.00058C-3.91033e-08 10.1064 0.895379 11.001 2.0004 11.001C3.08622 11.001 3.97119 10.1352 4 9.05419L4 8.94697C3.97119 7.86595 3.08622 7.00018 2.0004 7.00018C0.895379 7.00018 -1.35777e-07 7.89476 -8.74403e-08 9.00058Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.74403e-08 16.4049C-3.91383e-08 17.5099 0.895379 18.4053 2.0004 18.4053C3.08622 18.4053 3.97119 17.5387 4 16.4585L4 16.3513C3.97119 15.2694 3.08622 14.4021 2.0004 14.4021C0.895379 14.4021 -1.35777e-07 15.2991 -8.74403e-08 16.4049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsWhite);
export default __webpack_public_path__ + "static/media/actions-white.a107542a40bba50201e72d3ea3dcc6ae.svg";
export { ForwardRef as ReactComponent };